import '../App.css';
import '../styles/ourGoals.css'
import 'react-responsive-modal/styles.css';

/* DATA */
import litcGoals from '../data/goals.json';
import { Goal } from '../types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPeopleArrows, faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { faVoteYea } from '@fortawesome/free-solid-svg-icons';

function OurGoals() {
    const goals: Goal[] = litcGoals;
    const icons = {
        'people-arrows': faPeopleArrows,
        'vote': faVoteYea,
        'briefcase': faBriefcase
    }

    return (
        <div className='goals-section'>
            <h1 className='section-title'>Our Goals</h1>
            <p className='text-medium small'>Labour in The City are a forum for the City to hear from senior Labour leaders, and to present an expert voice to the Party to help support the best policy making. Our goals reflect that ethos.</p>
            <div className='goals-container'>
                {goals && goals.map((goal: Goal, key: number) => {
                    return (
                        <div className='goal-container'>
                            <div className='goal-icon'>
                                <FontAwesomeIcon icon={icons[goal.icon as keyof typeof icons]} className='goals-icons' size={'2x'}/>
                            </div>
                            <div className='goal-name'>
                                <p>{goal.name}</p>
                            </div>
                            <div className='goal-description'>
                                <p>{goal.description}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    );
}

export default OurGoals;
